// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
/* global localStorage */
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import Vue from 'vue';
import VueRouter from 'vue-router';
import VueResource from 'vue-resource';
import Vuex from 'vuex';
import VeeValidate from 'vee-validate';
import VueHead from 'vue-head';
import routes from './routes';
import App from './App';
import store from './store';
import i18Loader from './i18n';
import helpers from './helpers';
import moment from 'moment';
import urlParse from 'url-parse';

require('normalize.css');
require('./styles/style.scss');
require('./styles/app.scss');

const config = {
  strict: false,
};

Vue.use(ElementUI);
Vue.use(VueRouter);
Vue.use(VueResource);
Vue.use(Vuex);
Vue.use(VeeValidate, config);
Vue.use(VueHead);
Vue.use(helpers);

const router = new VueRouter({
  mode: 'history',
  linkActiveClass: 'active',
  routes,
  base: process.env.BASE,
});

Vue.http.headers.common.Authorization = `Bearer ${localStorage.getItem('id_token')}`;

// This interceptor fixes problem where invalid URLS are sent to the server
Vue.http.interceptors.push(function(request) {
  // Stop the request if it's got undefined in the URL
  if (String(request.url).indexOf("undefined") > -1) {
    return request.respondWith('{ "message": "Invalid request" }', {
      status: 404,
      statusText: 'Not found'
    });
  }
});

Vue.http.interceptors.push((request, next) => {
  if (router.currentRoute
      && router.currentRoute.query
      && (router.currentRoute.query.show === 'all' || router.currentRoute.query.show === 'deleted')
      && request.url.indexOf(router.currentRoute.params.id) != -1
      && request.url.indexOf('/list') === -1) {
    let url = urlParse(request.url, true);
    url.query.show = router.currentRoute.query.show;
    request.url = url.toString();
  }
  next((response) => {
    if (response.status === 401) {
      if (request.url !== `${process.env.BACKEND_API_URL}api/login` && !window.location.href.includes('password/reset') && !window.location.href.includes('conference/') && !window.location.href.includes('parking/session')) {
        store.dispatch('user/user/logout');
        router.push({ name: 'login' });
      }
    }
  });
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.noAuth)) {
    if (localStorage.getItem('id_token')) {
      next({ name: 'dashboard' });
    } else {
      next();
    }
  } else {
    next();
  }
});

router.afterEach((route) => {
  document.title = route.meta.title;
});

// init app after locales are loaded
i18Loader.then((i18n) => {

  Vue.http.headers.common['X-Locale'] = i18n.locale;
  moment.locale(i18n.locale);

  /* eslint-disable no-new */
  new Vue({
    router,
    store,
    i18n,
    template: '<App/>',
    components: { App },
  })
  .$mount('#app');
});



// WEBPACK FOOTER //
// ./src/main.js